import { render, staticRenderFns } from "./AboutBox.vue?vue&type=template&id=4994c0c0"
import script from "./AboutBox.vue?vue&type=script&lang=js"
export * from "./AboutBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports